import { bb_t } from '@src/models/baseElement'

export const isMac = navigator.userAgent.toLowerCase().indexOf('mac') !== -1

export const metaKeyPressed = (event: KeyboardEvent | MouseEvent): boolean => {
	return (isMac && event.metaKey) || (!isMac && event.ctrlKey) || event.altKey
}

export const metaAddNew = (): string => {
	return bb_t('metaA', 'entity')
}

export const shiftClickToFilter = (): string => {
	return bb_t('shiftClickToFilter', 'entity')
}

export const metaShiftClickToFilterFolder = (): string => {
	return bb_t('metaShiftClickToFilterFolder', 'entity')
}
